import { lazy } from 'react';

const HomePage = lazy(() => import('./HomePage'));
const GeneratorPage = lazy(() => import('./generator/GeneratorPage'));
const ImageLabelsPage = lazy(() => import('./image-labels/ImageLabelsPage'));
const LemonadePage = lazy(() => import('./lemonade/LemonadeSelectorPage'));
const LemonadeEditorPage = lazy(() => import('./lemonade-editor/LemonadeEditorPage'));
const QuestionViewerPage = lazy(() => import('./question-viewer/QuestionViewerPage'));
const LemonadeActivityPreviewPage = lazy(() => import('./lemonade-activity-preview/LemonadeActivityPreviewPage'));
const ScaffoldExamplePage = lazy(() => import('./scaffold-example/ScaffoldExamplePage'));
const ScaffoldMobilePage = lazy(() => import('./scaffold-example/ScaffoldMobilePage'));
const ScaffoldMobileCustomPage = lazy(() => import('./scaffold-example/ScaffoldMobileCustomPage'));
const ScaffoldingViewerPage = lazy(() => import('./scaffolding-viewer/ScaffoldingViewerPage'));
const StyleGuidePage = lazy(() => import('./style-guide/StyleGuidePage'));
const PlaygroundMathPage = lazy(() => import('./playground-math/PlaygroundMathPage'));
const AllQuestionsPage = lazy(() => import('./questions/AllQuestionsPage'));
const AllEditorsPage = lazy(() => import('./editors/AllEditorsPage'));
const ClockPage = lazy(() => import('./clock/ClockPage'));
const VideolessonPage = lazy(() => import('./videoLesson/VideoLessonPage'));
const MintPage = lazy(() => import('./mint/MintPage'));
const MintCoursePage = lazy(() => import('./mint/MintCoursePage'));
const AiPage = lazy(() => import('./ai/AiPage'));
const KCPlaygroundPage = lazy(() => import('./ai/KCPlaygroundPage'));
const ActivitiesPlaygroundPage = lazy(() => import('./ai/activities-playground/ActivitiesPlaygroundPage'));
const VideoRecorderPage = lazy(() => import('./video-recorder/VideoRecorderPage'));
const KcOrchestratorPage = lazy(() => import('./ai/kc-orchestrator/KcOrchestratorPage'));

export default {
  HomePage,
  GeneratorPage,
  ImageLabelsPage,
  LemonadePage,
  LemonadeEditorPage,
  QuestionViewerPage,
  LemonadeActivityPreviewPage,
  ScaffoldExamplePage,
  ScaffoldMobilePage,
  ScaffoldMobileCustomPage,
  ScaffoldingViewerPage,
  StyleGuidePage,
  PlaygroundMathPage,
  AllQuestionsPage,
  AllEditorsPage,
  ClockPage,
  VideolessonPage,
  MintPage,
  MintCoursePage,
  AiPage,
  VideoRecorderPage,
  KCPlaygroundPage,
  ActivitiesPlaygroundPage,
  KcOrchestratorPage,
};
